const installStudyRouter = [
  {
    path: "install-study",
    name: "install-study",
    component: (resolve) => require(["@views/install-study/index"], resolve),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "install-study-detail",
    name: "install-study-detail",
    component: (resolve) =>
      require(["@views/install-study/install-study-detail"], resolve),
  },
];

export default installStudyRouter;



// WEBPACK FOOTER //
// ./src/router/install-study/index.js